import axios from 'axios';
import authHeader from './auth-header';
import store from "../store";

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/user/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/user/';

class UserService {

  getTeamOfUser(userId) {
    return axios.get(API_URL + 'team/' + userId)
      .then((response) => {
        return response.data;
      })
  }

  async postUserSearch(category, tool, urlId, authorized, url, zone, browser, metaInfo = null) {
    if(JSON.parse(localStorage.getItem('user')).impostor){
      metaInfo = metaInfo ? JSON.parse(metaInfo) : {};
      metaInfo = JSON.stringify({...metaInfo,impostor:true,impostorName:store.getters['auth/impostor'].username});
    }
    let response = await axios.post(API_URL + 'search',
      {
        category: category,
        tool: tool,
        url_id: urlId,
        authorized: authorized,
        url: url,
        zone: zone,
        browser: browser,
        metaInfo: metaInfo
      }
    );
    return response;
  }

  putLastSearchRendered(request = {}){
    return axios.put(`${API_URL}search/rendered`, request);
  }

  putLastSearchOut(){
    return axios.put(`${API_URL}search/out`, null);
  }

  postUserLanguage(userId, languageId) {
    return axios.post(API_URL + 'language',
      {
        user: userId,
        language: languageId,
      }
    );
  }

  switchTheme(userId, theme) {
    return axios.put(`${API_URL}${userId}/theme/${theme}`, null
    );
  }

  getRoles() {
    return axios.get(API_URL + 'roles');
  }

  getUserTypes() {
    return axios.get(API_URL + 'types');
  }

  createUser(user) {
    return axios.post(API_URL, user);
  }

  updateUser(user) {
    return axios.put(API_URL, user);
  }

  updateUserByUser(user) {
    return axios.put(API_URL + "update/data", {id: user.id, firstName: user.firstName, lastName: user.lastName});
  }

  releaseUser(userId) {
    return axios.get(API_URL + userId + '/release');
  }

  updatePassword(user,force = 0) {
    return axios.put(`${API_URL}update-password/${force}`, user);
  }

  connectAs(userId) {
    return axios.get(API_URL + userId +"/connect");
  }

  postUserBug(bug){
    return axios.post(API_URL + "bug",bug);
  }

  getUserBugs(){
    return axios.get(API_URL + "bug");
  }

  updateBugState(updatedBug) {
    return axios.put(`${API_URL}bug/${updatedBug.id}/state`, updatedBug);
  }

  getUserInfo(id){
    return axios.get(`${API_URL}${id}`);
  }

  getUserInfoByEmail(email){
    return axios.post(`${API_URL}info`,{email:email});
  }

  switchMediaMode(mediaMode){
    return axios.put(`${API_URL}media/${mediaMode ? 1 : 0}`, null);
  }

  getAPIToken(){
    return axios.get(`${API_URL}api-token`);
  }

  generateAPIToken(){
    return axios.post(`${API_URL}api-token`, null);
  }

  getUnreadMessages(){
    return axios.get(`${API_URL}unread-messages`);
  }

  getUserActiveAlerts(userId) {
    return axios.get(`${API_URL}user-alerts/${userId}`)
  }

  putUserCurrency(currencyCode){
    return axios.put(`${API_URL}currency/${currencyCode}`,null)
  }

  putUserFieldColor(fieldColorCode){
    return axios.put(`${API_URL}field-color/${fieldColorCode}`,null)
  }

  putUserDefaultVisualization(defaultVisualization){
    return axios.put(`${API_URL}default-visualization/${defaultVisualization}`,null)
  }

  getDefaultStadium(){
    return axios.get(`${API_URL}default-stadium`);
  }

  createSquad(squad) {
    return axios.post(`${API_URL}squad`, squad);
  }

  deleteSquad(squadId) {
    return axios.delete(`${API_URL}${squadId}`);
  }

  loadSquad(id) {
    return axios.get(`${API_URL}squad/${id}`);
  }

  updateSquad(squad) {
    return axios.put(`${API_URL}squad/${squad.id}`,squad);
  }

  updateNotesOfPlayer(squadId, playerToUpdate) {
    return axios.put(`${API_URL}squad/${squadId}/notes`, playerToUpdate);
  }

  loadSquadList() {
    return axios.get(`${API_URL}squad/list`);
  }

  switchShowTour(userId, showTour) {
    return axios.put(`${API_URL}${userId}/show-tour/${showTour}`);
  }

  saveVideoFilters(videoFilters) {
    return axios.post(`${API_URL}video-filters`,videoFilters);
  }

  getVideoFilters(id) {
    return axios.get(`${API_URL}video-filters/${id}`);
  }

  updateVideoFilters(id,videoFilters) {
    return axios.put(`${API_URL}video-filters/${id}`,videoFilters);
  }

  deleteVideoFilters(id){
    return axios.delete(`${API_URL}video-filters/${id}`);
  }

  getAllPlaylists() {
    return axios.get(`${API_URL}video-filters`);
  }

  postShare(shareObject) {
    shareObject.type = shareObject.type ? shareObject.type : 'internal';
    return axios.post(`${API_URL}share`,shareObject);
  }

  getShares() {
    return axios.get(`${API_URL}share`);
  }

  loadShareToken(link) {
    return axios.post(`${API_URL}share/token`,{link});
  }

  getUserAlerts(onlyNotifications = true, size = 100) {
    return axios.get(`${API_URL}user-alerts`, { params: { onlyNotifications, size } });
  }

  getUnseenUserAlerts() {
    return axios.get(`${API_URL}user-alerts/unviewed`);
  }

  createUserAlert(newAlert) {
    return axios.post(`${API_URL}user-alerts`, newAlert);
  }

  updateAllUserAlertsAsViewed() {
    return axios.put(`${API_URL}user-alerts`);
  }

  updateUserAlertAsViewed(alertId) {
    return axios.put(`${API_URL}user-alerts/${alertId}`);
  }

  updateUserAlertAsViewedByTargetId(targetId) {
    return axios.put(`${API_URL}user-alerts/target/${targetId}`);
  }

  updateUserAlertAsViewedByType(typeId) {
    return axios.put(`${API_URL}user-alerts/type/${typeId}`);
  }

  updateUserAlertForUpdatedTask(eventCalendarId) {
    return axios.put(`${API_URL}user-alerts/updated-event/${eventCalendarId}`);
  }

  requestAccess(accessRequest) {
    return axios.post(`${API_URL}request-access/`, accessRequest);
  }

  getAccessRequests(){
    return axios.get(API_URL + 'request-access');
  }

  updateAccessRequests(updatedUserRequest) {
    return axios.put(`${API_URL}request-access/${updatedUserRequest.requestId}/state`, updatedUserRequest);
  }

  putUserFieldPositionCode(fieldPositionCode){
    return axios.put(`${API_URL}field-position-code/${fieldPositionCode}`, null);
  }

  putUserFieldLayout(fieldLayoutId){
    return axios.put(`${API_URL}field-layout/${fieldLayoutId}`, null);
  }

  putUserRatingFormat(ratingFormatId){
    return axios.put(`${API_URL}rating-format/${ratingFormatId}`, null);
  }

  switchShowMediaMode(showMediaMode) {
    return axios.put(`${API_URL}show-media-mode/${showMediaMode}`);
  }

  getRadarTemplates(){
    return axios.get(API_URL + "radar-templates");
  }

  postRadarTemplate(template){
    return axios.post(API_URL + "radar-templates",template);
  }

  putRadarTemplate(template){
    return axios.put(`${API_URL}radar-templates`,template);
  }

  removeRadarTemplate(templateId){
    return axios.delete(`${API_URL}radar-templates/${templateId}`);
  }

  postVisibilityRadarTemplate(templateId){
    return axios.post(`${API_URL}radar-visible/${templateId}`);
  }

  getGameH2HTemplates(fromPlayerScout = false){
    return axios.get(API_URL + "game-h2h-templates/player-scout/" + fromPlayerScout);
  }

  postGameH2HTemplate(template){
    return axios.post(API_URL + "game-h2h-templates",template);
  }

  putGameH2HTemplate(template){
    return axios.put(`${API_URL}game-h2h-templates`, template);
  }

  removeGameH2HTemplate(templateId){
    return axios.delete(`${API_URL}game-h2h-templates/${templateId}`);
  }

  postVisibilityStatTemplate(templateId){
    return axios.post(`${API_URL}template-visible/${templateId}`);
  }

}

export default new UserService();



// WEBPACK FOOTER //
// ./src/services/user.service.js